import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import CurrencySelector from './../CurrencySelector';
import { formValues } from 'redux-form';
import normalizePrice from 'lib/utils/normalizePrice';
import TicketingUrl from '../../TicketingUrl';
import styles from './ShortTicketFieldset.scss';
import PriceBreakdown from '../../PriceBreakdown';

const addCommas = value => {
  const onlyNums = value.replace(/[^\d]/g, '');
  return onlyNums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const ShortTicketFieldset = formValues({
  currency: 'currency',
  ticketingUrlType: 'ticketing_url_type',
  ticketsRequired: 'tickets_required',
  pricingType: 'pricing_type',
  prices: 'prices'
})(({ formErrors, currency, ticketingUrlType, pricingType, currencies, geotixEnabled, premiumEdit, ticketsRequired, prices }) => {
  if (!ticketsRequired || pricingType === 'free') { return null; }

  return <div className="ShortTicketFieldset">
    { pricingType === 'tickets_in_advance' && <div className="row">
      <div className="col-md-6">
        <FormField
          label='Ticket Name'
          name="prices[0].name"
          error={formErrors.getIn(['prices', '0', 'name'])}
          component="input"
          type="text"
          className="form-control"
          placeholder="General Admission"
          required
        />
      </div>
      <div className="col-md-3">
        <FormField
          name="prices[0].price"
          label="Ticket Price"
          error={formErrors.getIn(['prices', '0', 'price'])}
          component="input"
          type="text"
          className="form-control"
          placeholder="Enter the ticket price"
          normalize={normalizePrice}
          required
        />
      </div>
      <div className="col-md-3">
        <CurrencySelector
          label="Currency"
          formErrors={formErrors}
          currencies={currencies}
          currency={currency}
          error={formErrors.getIn(['prices', '0', 'currency'])}
          name={'prices[0].currency'}
        />
      </div>
    </div> }
    <div className="row">
      <div className="col-md-4">
        <FormField
          name="capacity"
          label="Capacity"
          error={formErrors.get('capacity')}
          component="input"
          type="text"
          className="form-control"
          placeholder="Enter the number of attendees"
          normalize={addCommas}
          required={ticketingUrlType === 'geotix'}
        />
      </div>
    </div>
    <div className="mb-3 font-italic">
      To add multiple tickets, click "Advanced form" above
    </div>
    <div className="row">
      <div className="col">
        <TicketingUrl
          formErrors={formErrors}
          geotixEnabled={geotixEnabled}
          premiumEdit={premiumEdit}
        />
      </div>
    </div>
    {ticketingUrlType === 'geotix' && pricingType === 'tickets_in_advance' && prices.length &&
      <div className={`row ${styles.Pricing}`}>
        <div className="col">
          <div className="card-header">
            <h4>Pricing</h4>
          </div>
          <div className="card-body">
            <PriceBreakdown price={prices[prices.length - 1].price}/>
          </div>
        </div>
      </div>
    }
  </div>;
});

ShortTicketFieldset.propTypes = {
  formErrors: PropTypes.object,
  currencies: PropTypes.array,
  premiumEdit: PropTypes.bool,
  geotixEnabled: PropTypes.bool.isRequired,
};

export default ShortTicketFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/ShortTicketFieldset.jsx